/* global translation */

import { updatePrice } from './functions';

const { closestByClassName } = require('./functions');

const productBundle = () => {
  const getAllCheckedOptions = () => Array.from(document.querySelectorAll('.add-to-bundle input:checked'));


  const validateSections = () => {
    const form = document.querySelector('.summary form.cart');

    if (!form) {
      return;
    }

    const { baseMinProducts, baseMaxProducts } = form.dataset;
    const sections = Array.from(document.querySelectorAll('.bundle-section'));
    const addToCartButtons = [];
    const mainAddToCartButton = document.querySelector('.cart .single_add_to_cart_button');
    const stickyAddToCartButton = document.querySelector('.sticky-product-inner .add-to-cart');

    addToCartButtons.push(mainAddToCartButton);
    addToCartButtons.push(stickyAddToCartButton);

    let isValid = true;

    if (baseMinProducts || baseMaxProducts) {
      const active = getAllCheckedOptions();
      form.classList.remove('not-valid');

      if (active.length < parseInt(baseMinProducts, 0) || active.length > parseInt(baseMaxProducts, 0)) {
        isValid = false;
        form.classList.add('not-valid');
      }
    }

    if (sections) {
      sections.forEach((section) => {
        const { minProducts, maxProducts } = section.dataset;
        if (minProducts || maxProducts) {
          const active = Array.from(section.querySelectorAll('input:checked'));
          section.classList.remove('not-valid');

          if (active.length < parseInt(minProducts, 0) || active.length > parseInt(maxProducts, 0)) {
            isValid = false;
            section.classList.add('not-valid');
          }
        }
      });
    }

    if (isValid) {
      addToCartButtons.forEach((button) => {
        button.classList.remove('disabled');
      });
    } else {
      addToCartButtons.forEach((button) => {
        button.classList.add('disabled');
      });
    }
  };
  validateSections();


  const generatePriceHtml = (price) => {
    const priceContainer = document.createElement('span');
    const currencyContainer = document.createElement('span');
    priceContainer.className = 'woocommerce-Price-amount amount';

    currencyContainer.className = 'woocommerce-Price-currencySymbol';
    currencyContainer.innerText = translation.products.currency_symbol;

    priceContainer.innerHTML = `${price} `;
    priceContainer.appendChild(currencyContainer);

    return priceContainer;
  };


  const generatePriceContainerHtml = (price, regularPrice) => {
    if (price === regularPrice) {
      return generatePriceHtml(price);
    }

    const priceContainer = document.createElement('span');
    const delContainer = document.createElement('del');
    const insContainer = document.createElement('ins');
    priceContainer.className = 'price';

    delContainer.innerHTML = generatePriceHtml(regularPrice).outerHTML;
    insContainer.innerHTML = generatePriceHtml(price).outerHTML;

    priceContainer.appendChild(delContainer);
    priceContainer.appendChild(insContainer);

    return priceContainer;
  };


  const buildDropdowns = () => {
    const sections = Array.from(document.querySelectorAll('.bundle-section'));

    sections.forEach((section) => {
      if (section.classList.contains('is-dropdown')) {
        const toggleButtons = Array.from(section.querySelectorAll('.toggle-product-bundles'));
        const smallToggleButton = section.querySelector('.toggle-product-bundles.small');

        toggleButtons.forEach((toggleButton) => {
          toggleButton.addEventListener('click', (event) => {
            event.preventDefault();
            section.classList.toggle('dropdown-open');

            if (section.classList.contains('dropdown-open')) {
              smallToggleButton.innerText = translation.close; // eslint-disable-line
            } else {
              smallToggleButton.innerText = translation.edit; // eslint-disable-line
            }
          });
        });
      }
    });
  };
  buildDropdowns();


  const buildDropdownSelectedRows = (section) => {
    if (!section.classList.contains('is-dropdown')) {
      return;
    }

    const selected = Array.from(section.querySelectorAll('input:checked'));
    const outputContainer = section.querySelector('.selected-products');
    const rows = Array.from(outputContainer.querySelectorAll('.selected-products-row'));

    // Clear existing
    rows.forEach((row) => {
      row.remove();
      section.classList.remove('have-selected');
    });

    if (selected) {
      selected.forEach((check) => {
        const row = closestByClassName(check, 'bundled-product');
        const output = outputContainer.querySelector('.selected-products-row-copy-me').cloneNode(true);

        output.className = 'selected-products-row';
        output.querySelector('.image').innerHTML = row.querySelector('.thumbnail').innerHTML;
        output.querySelector('.name').innerHTML = row.querySelector('.product-info h4').innerHTML;
        output.querySelector('.price').innerHTML = row.querySelector('.price').innerHTML;

        outputContainer.appendChild(output);

        section.classList.add('have-selected');
      });
    }
  };


  const calculatePrice = () => {
    let totalRegularExtra = 0;
    let totalExtra = 0;
    let { baseRegularPrice, basePrice } = document.querySelector('.entry-summary form.cart').dataset;

    if (baseRegularPrice) {
      baseRegularPrice = parseInt(baseRegularPrice, 0);
    }

    if (basePrice) {
      basePrice = parseInt(basePrice, 0);
    }

    getAllCheckedOptions().forEach((option) => {
      const { price, regularPrice } = option.dataset;
      totalExtra += parseInt(price, 0);
      totalRegularExtra += parseInt(regularPrice, 0);
    });

    return {
      price: basePrice + totalExtra,
      regularPrice: baseRegularPrice + totalRegularExtra,
    };
  };


  const updatePriceContainers = () => {
    const priceContainers = [];
    priceContainers.push(document.querySelector('.entry-summary .rating-price-col .price'));
    priceContainers.push(document.querySelector('.sticky-product-inner .product-price'));
    priceContainers.push(document.querySelector('.product-header .price'));

    const prices = calculatePrice();

    priceContainers.forEach((container) => {
      container.innerHTML = generatePriceContainerHtml(prices.price, prices.regularPrice).outerHTML; // eslint-disable-line
    });

    const subscriptionPrices = Array.from(document.querySelectorAll('.subscription-option-details .delivery-price'));

    if (subscriptionPrices) {
      subscriptionPrices.forEach((delivery) => {
        const deliveryPriceContainer = delivery.querySelector('.price-container');
        if (deliveryPriceContainer) {
          let percentage = 0;

          if (delivery.dataset.subscriptionDiscountPercentage) {
            percentage = delivery.dataset.subscriptionDiscountPercentage;
          }

          const discount = (percentage / 100) * prices.regularPrice;
          const newPrice = prices.regularPrice - discount;

          updatePrice(deliveryPriceContainer, newPrice);
        }
      });

      const subscriptionBasePrice = document.querySelector('.wcsatt-options-product li.subscription-option .subscription-base-price');

      if (subscriptionBasePrice) {
        updatePrice(subscriptionBasePrice, prices.regularPrice);
      }
    }
  };
  // setTimeout(updatePriceContainers, 100);
  updatePriceContainers();


  const buildPriceUpdated = () => {
    const options = Array.from(document.querySelectorAll('.add-to-bundle input'));

    if (options) {
      options.forEach((option) => {
        option.addEventListener('change', (event) => {
          event.preventDefault();
          updatePriceContainers();
          buildDropdownSelectedRows(closestByClassName(option, 'bundle-section'));
          validateSections();
        });
      });
    }
  };
  buildPriceUpdated();


  const maybeInsertFromPrice = () => {
    const haveFromPrice = document.querySelector('.display-from-price-faker');
    if (haveFromPrice) {
      const priceContainers = [];
      priceContainers.push(document.querySelector('.entry-summary .rating-price-col .price'));
      priceContainers.push(document.querySelector('.sticky-product-inner .product-price'));
      priceContainers.push(document.querySelector('.product-header .price'));

      priceContainers.forEach((container) => {
        container.innerHTML = haveFromPrice.innerHTML; // eslint-disable-line
      });
    }
  };
  setTimeout(maybeInsertFromPrice, 20);
};

if (document.body.classList.contains('product-type-lnda-bundle-products')) {
  if (document.querySelector('.lnda_bundle_data')) {
    productBundle();
  }
}
